<template>
  <section class="sponsors general">
    <div class="sponsors__content">
      <h1 class="sponsors__title">
          Presenting Companies
      </h1>
      <div class="sponsors__logos">
        <template v-for="partner in partners" :key="partner.name">
          <a v-if="partner.url" :href="partner.url" target="_blank">
            <div
              class="sponsors__item single smaller"
            >
              <div class="sponsors__logo-container nobg">
                <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
              </div>
            </div>
          </a>
          <div
            v-else
            class="sponsors__item single smaller"
          >
            <div class="sponsors__logo-container nobg">
              <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@/styles/components/sponsors.scss';
</style>

<script>
import { ref } from 'vue';

export default {
  setup() {
    const partners = ref([
      { logo: require('@/assets/logos/zeebu.png'), class: 'full-logo', name: 'Zeebu', url: 'http://zeebu.com/' },
      { logo: require('@/assets/logos/midnight.svg'), class: 'full-logo', name: 'Midnight', url: 'https://midnight.network/' },
      { logo: require('@/assets/logos/rizzo.svg'), class: 'logo', name: 'Rizzo Network', url: 'https://rizzo.network/' },
      { logo: require('@/assets/logos/bancor.png'), class: 'full-logo', name: 'Bancor', url: 'https://bancor.network/' },
      { logo: require('@/assets/logos/climate.svg'), class: 'full-logo', name: 'Climate Trade', url: 'https://climatetrade.com/' },
      { logo: require('@/assets/logos/mentat.svg'), class: 'logo', name: 'Mentat Minds', url: 'https://www.mentatminds.com/' },
      { logo: require('@/assets/logos/omron.svg'), class: 'full-logo', name: 'Omron AI', url: 'https://omron.ai/' },
      { logo: require('@/assets/logos/hyperagent.png'), class: 'full-logo', name: 'HyperAgent', url: 'https://hyperagent.io/' },
      { logo: require('@/assets/logos/inference2.svg'), class: 'full-logo', name: 'Inference Labs', url: 'https://inferencelabs.com/' },
      { logo: require('@/assets/logos/resi.svg'), class: 'full-logo', name: 'Resi', url: 'https://resilabs.ai/' },
      { logo: require('@/assets/logos/talisman.svg'), class: 'full-logo', name: 'Talisman', url: 'https://talisman.xyz/' },
      { logo: require('@/assets/logos/naoris.svg'), class: 'full-logo', name: 'Naoris', url: 'https://www.naorisprotocol.com/' },
      { logo: require('@/assets/logos/matterfi.svg'), class: 'full-logo', name: 'MatterFi', url: 'https://www.matterfi.com/' },
      { logo: require('@/assets/nashville/sponsors/kredete.png'), class: 'full-logo', name: 'Kredete', url: 'https://www.kredete.com/' },
    ]);
    return {
      partners
    };
  },
};
</script>